import { reactive, readonly } from 'vue';

const state = reactive({
    visible: false,
    message: '',
    type: 'info' as 'success' | 'error' | 'info' | 'warning',
    timeout: 3000,
})

let timer: ReturnType<typeof setTimeout>;

export function useSnackbar() {
    function show(message: string, options?: { type?: typeof state.type; timeout?: number }) {
        clearTimeout(timer);
        state.message = message;
        state.type = options?.type || 'info';
        state.timeout = options?.timeout || 3000;
        state.visible = true;
        
        timer = setTimeout(() => { state.visible = false }, state.timeout);
    }
    function dismiss() {
        clearTimeout(timer);
        state.visible = false;
    }

    return { state: readonly(state), show, dismiss };
}
